<template>
    <div :class="keyboardClass"></div>
</template>

<script lang="js">

  import { mapActions, mapState } from 'vuex'

  import 'simple-keyboard/build/css/index.css'

  export default  { 
    name: 'game',
    props: {
      keyboardClass: {
        default: "simple-keyboard",
        type: String
      },
      input: {
        type: String
      }
    },
    
    components: {},

    data() {
      return {
        keyboard: null
      }
    },

    mounted () {
      // this.createKeyboard()
    },

    destroyed() {
      this.setIsPlaying(false)
    },

    methods: {
      ...mapActions({
        // createKeyboard: 'keyboard/createKeyboard',
        setIsPlaying: 'game/setIsPlaying',
      }),
    },

    computed: {
      ...mapState({
        completed: state => state.game.completed,
      }),
      
    }
  }

</script>


<style scoped lang="scss">

  @import '@puzzleapps/shared/src/style/variables';

  .simple-keyboard {
    // display: none;
    border-radius: 0;
    background: whitesmoke;
    padding: 20px;    
    border: 1px solid #eaeaea;

    order: 2;
    width: 20%;
    left: 0;
    // margin-bottom: 1.3%;

    // target mobile/touch devices at any size
    @media only screen and (hover: none) and (pointer: coarse) {
      display: block!important;
    }
        // also target any device which is under 600px
    @media (max-width: 600px) {
      display: block!important;
    }

    &::v-deep {
      .hg-theme-default .hg-button {
        flex: 1;
      }
      .hg-row {
        margin-bottom: 10px;
      }
      .hg-button {
        box-shadow: 0 3px 0 #cccccc;
        border: 1px solid #f3f3f3;
        font-size: 1.3rem;
        font-weight: 400;
        color: #3c3c3c;
        background: white;
        height: 36px;

        &.disabled {
          pointer-events: none;
          opacity: 0.5;
          color: rgb(212, 212, 212);
          background-color: #727272;
        }

        &.incorrect{
          color: red;
          background-color: #f7d3d3;
        }
        &.used{
          color: green;
          background-color: rgb(172, 231, 172);
        }
        &.challenged-used{
          color: rgb(0, 0, 0);
          background-color: #dddddd;
        }
      }
    }
  }

</style>
